import React from "react";

/* Numbered instructions for what happens outside Definable — in Telegram, in
   Slack, on the phone — in the order they happen. */
export function Steps({ items }: { items: React.ReactNode[] }) {
  return (
    <ol className="m-0 p-0 list-none space-y-2">
      {items.map((item, i) => (
        // The list is fixed per dialog, so its position is its identity.
        <li key={i} className="flex items-start gap-2.5 text-[13px] leading-[1.5] text-[var(--text-secondary)]">
          <span className="shrink-0 w-[18px] h-[18px] rounded-full bg-[var(--surface-2)] ring-1 ring-[var(--hairline)] flex items-center justify-center font-mono text-[11px] tabular-nums text-[var(--text-tertiary)]">
            {i + 1}
          </span>
          <div className="min-w-0 flex-1">{item}</div>
        </li>
      ))}
    </ol>
  );
}
